import './index.css';

import App from './App';
import AuthContextProvider from './Components/Context/AuthContext/AuthContext';
import DataContextProvider from './Components/Context/DataContext/DataContext';
import React from 'react';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthContextProvider>
    <DataContextProvider>
      <App />
    </DataContextProvider>
  </AuthContextProvider>
);
